/**
 * Page titles: one place for the brand suffix and for tidying generated titles.
 *
 * The blog cron's titles come from GPT, and a few arrived wrapped in quotes or
 * carrying their own brand ("…Resume | InMyResume.com"), which then got a second
 * suffix from the template.
 */

export const BRAND = 'InMyResume'
const SUFFIX = ` | ${BRAND}`

/**
 * Google shows roughly 60 characters of a title before cutting it off. Past
 * that the brand suffix is the part that disappears anyway, so it is left off
 * and the words that describe the page stay visible.
 */
export const MAX_TITLE_LENGTH = 60

const QUOTES = /^["'“”„]+|["'“”„]+$/g
const TRAILING_BRAND = /\s*[|–—-]\s*InMyResume(\.com)?\s*$/i

/** Text without the quotes GPT sometimes wraps a whole title or description in. */
export function stripQuotes(text?: string | null): string {
  return (text ?? '').trim().replace(QUOTES, '').trim()
}

/**
 * The title without wrapping quotes or a trailing brand, for headings and
 * anywhere else the brand does not belong.
 */
export function cleanTitle(title?: string | null): string {
  if (!title) return ''
  return title.trim().replace(QUOTES, '').trim().replace(TRAILING_BRAND, '').replace(QUOTES, '').trim()
}

/**
 * The site's `titleTemplate`. A title that already ends in the brand chose it
 * (the homepage does, see seo.homepage) and keeps it, spelled one way. Any other
 * title gets the suffix only when the whole thing still fits.
 */
export function brandedTitle(title?: string | null): string {
  const clean = cleanTitle(title)
  if (!clean) return `${BRAND} - your resume in minutes`
  const choseBrand = TRAILING_BRAND.test(title!.trim().replace(QUOTES, '').trim())
  if (choseBrand) return `${clean}${SUFFIX}`
  return clean.length + SUFFIX.length <= MAX_TITLE_LENGTH ? `${clean}${SUFFIX}` : clean
}
